<div class="layer-form-wrapper">
  <h2>{{ 'global-forms.layer.title' | translate }}</h2>

  <form id="form" class="details-form" (ngSubmit)="onSubmit(form)" [formGroup]="form" novalidate>

    <div class="form-row name-wrapper">
      <mat-form-field>
        <input matInput formControlName="Name" name="Name" placeholder="{{ 'layers.form.Name' | translate }}" required />
        <span matSuffix>{{ form.get("Slug").value }}</span>
        <mat-error *ngIf="isRequiredError('Name')">
          {{ 'validation.required' | translate: {name: ('layers.form.Name' | translate)} }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" *ngIf="isSuperAdmin">
      <mat-form-field>
        <input [maxLength]="identifierMaxLength" matInput formControlName="Slug" name="slug" placeholder="{{ 'layers.form.Slug' | translate }}" required/>
        <mat-error *ngIf="isRequiredError('Slug')">
          {{ 'validation.required' | translate: {name: ('layers.form.Slug' | translate)} }}
        </mat-error>
        <mat-error *ngIf="form.controls.Slug.errors && form.controls.Slug.errors.pattern">
          {{ 'validation.is_not_valid' | translate: {name: ('layers.form.Slug' | translate)} }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field>
        <mat-select
          formControlName="Scope"
          disabled
          required
          placeholder="{{ 'permissions.visibility' | translate }}"
        >
          <mat-option [value]="scopes.CompanyScope">
            {{ 'permissions.scope.company' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="color-attribute">
      <div class="selected-color">
        <p class="label">Color</p>
        <mee-color-picker formControlName="LayerColor"></mee-color-picker>
      </div>
    </div>

    <div class="category">
      <mee-category-autocomplete
        [editModeCategoryName]="editModeCategoryName"
        (categoryNameChanged)="onCategoryNameChanged($event)"
      ></mee-category-autocomplete>
    </div>

    <div class="buttons">
      <button mat-ripple class="cancel-button" (click)="cancel()"
              type="button">{{ 'global-forms.cancel' | translate }}</button>
      <button mat-ripple class="apply-button" type="submit">{{ 'global-forms.add' | translate }}</button>
    </div>
  </form>

</div>
